<script setup>
defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  theme: {
    type: String,
    default: 'light',
  },
});

const emit = defineEmits(['click']);
</script>

<template>
  <button
    class="cursor-pointer mobile-only icon-menu"
    aria-label="menu"
    :class="{ 'icon-menu_active': active }"
    @click="emit('click')"
  >
    <span
      class="no-events"
      :class="{
        'bg-inverse': theme === 'light',
        'bg-base': theme === 'dark',
      }"
    >
      <span class="icon-menu__before" :class="{ 'bg-inverse': theme === 'light', 'bg-base': theme === 'dark' }"></span>
      <span class="icon-menu__after" :class="{ 'bg-inverse': theme === 'light', 'bg-base': theme === 'dark' }"></span>
    </span>
  </button>
</template>

<style lang="scss">
.icon-menu {
  display: block;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  position: relative;
}

.icon-menu span,
.icon-menu__before,
.icon-menu__after {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  left: 50%;
  margin-left: -10px;
  width: 20px;
  height: 2px;
}

.icon-menu__before,
.icon-menu__after {
  display: block;
  transition: 0.2s;
}

.icon-menu__before {
  transform: translateY(-5px);
}

.icon-menu__after {
  transform: translateY(5px);
}

.icon-menu_active .icon-menu__before {
  transform: rotate(-35deg);
  width: 10px;
  transform-origin: left bottom;
}

.icon-menu_active .icon-menu__after {
  transform: rotate(35deg);
  width: 10px;
  transform-origin: left top;
}
</style>
